/**
 * Creates a listener function that can be added to a workspace.
 *
 * @param {object} workspace - The workspace object to add the listener to.
 * @param {object} disposable - The disposable object that holds the listener.  The listenr
 * will be removed when the disposable is disposed.
 * @param {function} callback - The callback function to be executed when the workspace changes.
 * @returns {function} - A function that removes the listener from the workspace.
 */
module.exports = function createListener(workspace, disposable, callback) {
    if (!workspace.listeners_.includes(callback)) {
        workspace.addChangeListener(callback);
    }
    // Blockly doesn't really give us a great way to clean up if somebody just
    // blows away the input containing the field.  So we'll monkey patch dispose
    // on this instance so we can clean up when it is called.
    const holdDispose = disposable.dispose;
    disposable.dispose = function () {
        workspace.removeChangeListener(callback);
        holdDispose.call(disposable);
    };
    return function () {
        workspace.removeChangeListener(callback);
    };
};
